import {Pipe, PipeTransform} from "@angular/core";
@Pipe({
    name: 'filter'
})
export class FilterPipe implements PipeTransform {
    transform(objects:any[],attr:string, val:any):any {
        if(objects) {
        return objects.filter(object => {
                return object[attr] === val ;
            });
            
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/pipes/filter.pipe.ts